/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, September 9th 2022, 8:09:26 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { useWorkflowContext } from "service-builder/providers";
import { useReactFlowAdapter, ReactFlowContext as FlowChartContext } from "service-builder/adapters/ReactFlowAdapter"; // Hot-swappable

interface FlowChartProviderProps {
  children: React.ReactNode;
}
export const FlowChartProvider = ({ children }: FlowChartProviderProps) => {
  const workflowContext = useWorkflowContext();

  const flowchartContextValue = useReactFlowAdapter(workflowContext);

  return <FlowChartContext.Provider value={flowchartContextValue}>{children}</FlowChartContext.Provider>;
};
